<template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="12">
                <h3>{{$route.name}}</h3>
                <b-breadcrumb>
                    <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item><router-link to="/vehicle">Vehicle Dashboard</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
        </b-row>
        <div class="border-bottom mb-3"/>
        <!-- <div>
            <b-alert show v-if="model.repair !== null" variant="danger" style="font-weight:bold!important;"><i>This vehicle is being repaired</i></b-alert>
        </div> -->
        <template v-if="isLoading">
            <div class="d-flex justify-content-center mb-5 mt-5 pt-5 pb-5">
                <b-spinner style="width: 3rem; height: 3rem;" variant="primary" label="Loading..."></b-spinner>
            </div>
        </template>
        <template v-else>
            <b-form class="mt-2">
                <b-row class="mt-2 mb-3">
                  <div class="icon-flag"></div>
                  <b-col md="6 mt-2">
                    <b-button disabled pill variant="outline-primary" style="font-weight:bold!important;font-size:13px!important;margin-left:-15px!important;" :href="'#'">Company: {{model.company}}</b-button>
                    <b-button class="ml-2" disabled pill variant="outline-primary" style="font-weight:bold!important;font-size:13px!important;" :href="'#'">Branch: {{model.branch}}</b-button>
                  </b-col>
                </b-row>
                <b-row>
                    <b-col md="6">
                        <b-row>
                            <b-col md="4"><label class="labels">Brand</label></b-col>
                            <b-col md="8"><p>{{ model.merk !== null ? model.merk : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">Model</label></b-col>
                            <b-col md="8"><p>{{ model.model !== null ? model.model : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">Year</label></b-col>
                            <b-col md="8"><p>{{ model.year !== null ? model.year : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">Plate</label></b-col>
                            <b-col md="8"><p>{{ model.plate !== null ? model.plate : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">Category</label></b-col>
                            <b-col md="8"><p>{{ model.category.name !== null ? model.category.name : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">Chassis Number</label></b-col>
                            <b-col md="8"><p>{{ model.chassisNumber !== null ? model.chassisNumber : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">Machine Number</label></b-col>
                            <b-col md="8"><p>{{ model.machineNumber !== null ? model.machineNumber : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">Owner</label></b-col>
                            <b-col md="8"><p>{{ model.owner !== null ? model.owner : '-' }}</p></b-col>
                        </b-row>
                    </b-col>
                    <b-col md="6">
                        <b-row>
                            <b-col md="4"><label class="labels">Color</label></b-col>
                            <b-col md="8"><p>{{ model.color !== null ? model.color : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">Fuel</label></b-col>
                            <b-col md="8"><p>{{ model.fuel !== null ? model.fuel : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">Engine</label></b-col>
                            <b-col md="8"><p>{{ model.engine !== null ? model.engine : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">Transmission</label></b-col>
                            <b-col md="8"><p>{{ model.transmission !== null ? model.transmission : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">Mileage</label></b-col>
                            <b-col md="8"><p>{{ model.mileage !== null ? model.mileage : '-' }}</p></b-col>
                        </b-row>
                        <!-- <b-row>
                            <b-col md="4"><label class="labels">Status</label></b-col>
                            <b-col md="8"><p><b-badge :variant="getStatusColor(model.status)">{{getStatusName(model.status)}}</b-badge></p></b-col>
                        </b-row> -->
                        <!-- <b-row>
                            <b-col md="4"><label class="labels">Next Service</label></b-col>
                            <b-col md="8"><p>{{ model.nextservice !== null ? model.nextservice : '-' }}</p></b-col>
                        </b-row> -->
                        <b-row>
                            <b-col md="4"><label class="labels">Insurance</label></b-col>
                            <b-col md="8"><p>{{ model.insurance !== null ? model.insurance : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">Road Tax</label></b-col>
                            <b-col md="8"><p>{{ model.roadtax !== null ? model.roadtax : '-' }}</p></b-col>
                        </b-row>
                        <!-- <b-row>
                            <b-col md="4"><label class="labels">Company</label></b-col>
                            <b-col md="8"><p>{{ model.company !== null ? model.company : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">Branch</label></b-col>
                            <b-col md="8"><p>{{ model.branch !== null ? model.branch : '-' }}</p></b-col>
                        </b-row> -->
                        <b-row>
                            <b-col md="4"><label class="labels">Note</label></b-col>
                            <b-col md="8" v-if="model.repair === null"><p>{{ model.note !== '' ? model.note : '-' }}</p></b-col>
                            <b-col md="8" v-else-if="model.repair !== null"><p>{{ model.noteRepair !== '' ? model.noteRepair : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">Status</label></b-col>
                            <b-col md="8"><p><b-badge :variant="getStatusColor(model.status)">{{getStatusName(model.status)}}</b-badge></p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">Driven By</label></b-col>
                            <b-col md="8"><p>{{ model.drivenBy !== null ? model.drivenBy : '-' }}</p></b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="mt-3 mb-2">
                        <h5>Photo</h5>
                    </b-col>
                    <b-col md="12">
                        <b-row v-if="model.vehiclePhotoList.length === 0">
                            <b-col md="3 py-1">
                              <p class="text-secondary text-center border border-radius p-2" style="background-color:#f5f5f5"><b-img :src="'/img/general/Imagexhdpi.png'" class="img-responsive" width="70" height="60"/><br><br><i>No Photo Submitted</i></p>
                            </b-col>
                            <b-col md="2">
                                <b-col md="1 mt-5 ml-4">
                                    <b-button variant="primary" class="float-right btn-custom" @click="showModal"><font-awesome-icon icon="plus"/></b-button>
                                </b-col>
                              <!-- <b-button class="p-3 border-radius" variant="primary" @click="showModal" style="margin-top:4rem;">
                                  <font-awesome-icon icon="plus" style="font-size:30px"/> 
                                  <p class="mt-3 mb-0">Add Photo</p>
                              </b-button> -->
                            </b-col>
                        </b-row>
                        <viewer :images="model.vehiclePhotoList" v-else>
                            <b-row>
                                <b-col md="3" v-for="(src, index) in model.vehiclePhotoList" :key="index">
                                    <p class="text-secondary text-center border p-5" v-if="src === null"><i>No Photo Submitted</i></p>
                                    <b-img v-else :src="src" class="img-responsive mt-2 pl-2" width="225" height="175"/>
                                </b-col>
                                <b-col md="2 mt-4" v-if="model.vehiclePhotoList.length <= 2">
                                    <b-col md="1 mt-5 float-right">
                                        <b-button variant="primary" class="float-right btn-custom" @click="showModal"><font-awesome-icon icon="plus"/></b-button>
                                    </b-col>
                                  <!-- <b-button class="mt-4 p-3 border-radius" variant="primary" @click="showModal">
                                      <font-awesome-icon icon="plus" style="font-size:30px"/> 
                                      <p class="mt-3 mb-0">Add Photo</p>
                                  </b-button> -->
                                </b-col>
                            </b-row>
                        </viewer>
                    </b-col>
                </b-row>
                <b-row>
                  <b-col md="12" class="mt-5 mb-1">
                    <b-tabs id="nav-tabs-div" class="border-top">
                      <template v-slot:tabs-end>
                        <b-nav-item @click="activeTab = 'RoadTax'" :class="{activeClassy : activeTab === 'RoadTax'}">Road Tax</b-nav-item>
                        <b-nav-item @click="activeTab = 'Service'" :class="{activeClassy : activeTab === 'Service'}">Service</b-nav-item>
                        <b-nav-item @click="activeTab = 'Penalty'" :class="{activeClassy : activeTab === 'Penalty'}">Penalty</b-nav-item>
                        <b-nav-item @click="activeTab = 'Repair'" :class="{activeClassy : activeTab === 'Repair'}">Repair</b-nav-item>
                        <b-nav-item @click="activeTab = 'Insurance'" :class="{activeClassy : activeTab === 'Insurance'}">Insurance</b-nav-item>
                        <!--<b-nav-item @click="activeTab = 'Other Report'">Other Report</b-nav-item>-->
                        <b-nav-item @click="activeTab = 'User History'" :class="{activeClassy : activeTab === 'User History'}">User History</b-nav-item>
                      </template>
                      <div class="nav-content">
                        <div v-if="activeTab === 'RoadTax'" key="roadtax" class="nav-content-detail">
                          <div class="content-detail">
                            <RoadTax :vehicleUuid="model.uuid !== undefined ? model.uuid : null" />
                          </div>
                        </div>
                        <div v-if="activeTab === 'Service'" key="service" class="nav-content-detail">
                          <div class="content-detail">
                            <Service :vehicleUuid="model.uuid !== undefined ? model.uuid : null" />
                          </div>
                        </div>
                        <div v-if="activeTab === 'Penalty'" key="penalty" class="nav-content-detail">
                          <div class="content-detail">
                            <Penalty :vehicleUuid="model.uuid !== undefined ? model.uuid : null" />
                          </div>
                        </div>
                        <div v-if="activeTab === 'Repair'" key="repair" class="nav-content-detail">
                          <div class="content-detail">
                            <Repair :vehicleUuid="model.uuid !== undefined ? model.uuid : null" />
                          </div>
                        </div>
                        <div v-if="activeTab === 'Insurance'" key="insurance" class="nav-content-detail">
                          <div class="content-detail">
                            <Insurance :vehicleUuid="model.uuid !== undefined ? model.uuid : null" />
                          </div>
                        </div>
                        <div v-if="activeTab === 'User History'" key="userhistory" class="nav-content-detail">
                          <div class="content-detail">
                            <UserHistory :vehicleUuid="model.uuid !== undefined ? model.uuid : null" />
                          </div>
                        </div>
                        <div v-if="activeTab === 'Other Report'" key="otherreport" class="nav-content-detail">
                          <div class="content-detail">
                            <OtherReport :vehicleUuid="model.uuid !== undefined ? model.uuid : null" />
                          </div>
                        </div>
                      </div>
                    </b-tabs>
                  </b-col>
                </b-row>
                <!-- <b-modal ref="my-modal" centered hide-footer :title="(model.id === '' ? 'Add' : 'Edit') + ' Vehicle Photo'"> -->
                <b-modal ref="my-modal" centered hide-footer :title="'Add Vehicle Photo'">
                  <form v-on:submit.prevent="doSendPhoto">
                      <label>Photo *</label>
                      <b-form-file :required="true" label="Photo" v-model="model.photo1" for-input="photo1roupFile" :error="errors.first('photo1')">
                      </b-form-file>
                      <!--<b-form-file :required="true" v-model="model.photo1" label="Photo 1" for-input="photo1inputGroupFile" :error="errors.first('photo1')">
                          <div class="input-group">
                              <div class="custom-file">
                                  <input class="custom-file-input" v-model="model.photo1" @change="onFileSelected" ref="photo1" id="photo1inputGroupFile" accept="image/*" name="photo1" v-validate="modelValidations.photo1" :error="errors.first('photo1')" data-vv-as="photo 1" />
                                  <label class="custom-file-label" for="photo1inputGroupFile">{{data.photo1File !== null ? data.photo1File.name : 'Choose file'}}</label>
                              </div>
                              <div v-if="data.photo1File !== null" class="input-group-append">
                                  <span class="input-group-text bg-danger text-white pointer" title="Clear Image" @click="clearImage"><font-awesome-icon icon="times"/></span>
                              </div>
                          </div>
                      </b-form-file>-->
                      <br><br>
                      <!--<label>Photo 2 *</label>
                      <b-form-file :required="true" label="ID Card Photo" v-model="model.photo2" for-input="idCardGroupFile" :error="errors.first('photo2')">
                      </b-form-file>
                      <!--<b-form-file :required="false" v-model="model.photo2" label="Photo 2" for-input="photo2inputGroupFile" :error="errors.first('photo2')">
                          <div class="input-group">
                              <div class="custom-file">
                                  <input class="custom-file-input" v-model="model.photo2" @change="onFileSelectedPhoto2" ref="photo2" id="photo2inputGroupFile" accept="image/*" name="photo2" :error="errors.first('photo2')" data-vv-as="photo 2">
                                  <label class="custom-file-label" for="photo2inputGroupFile">{{data.photo2File !== null ? data.photo2File.name : 'Choose file'}}</label>
                              </div>
                              <div v-if="data.photo2File !== null" class="input-group-append">
                                  <span class="input-group-text bg-danger text-white pointer" title="Clear Image" @click="clearImagePhoto2"><font-awesome-icon icon="times"/></span>
                              </div>
                          </div>
                      </b-form-file>
                      <br><br>
                      <label>Photo 3 *</label>
                      <b-form-file :required="true" label="ID Card Photo" v-model="model.photo3" for-input="idCardGroupFile" :error="errors.first('photo3')">
                      </b-form-file><br><br>-->
                      <b-button variant="secondary" @click="hideModal">
                          <font-awesome-icon icon="times" class="text-white"/> Cancel
                      </b-button>
                      <b-button variant="primary" class="float-right" type="submit">
                          <font-awesome-icon icon="save"/> Submit
                      </b-button>
                  </form>
                </b-modal>
            </b-form>
            <b-button class="mt-3" :to="'/vehicle'" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
            <b-button class="mt-3 float-right" :to="'/vehicle/' + $route.params.uuid + '/edit'" variant="warning"><font-awesome-icon icon="pencil-alt"></font-awesome-icon> Edit</b-button>

        </template>
    </b-card>
</template>

<script>
    import 'viewerjs/dist/viewer.css'
    import Viewer from 'v-viewer'
    import RoadTax from './RoadTax/RoadTax'
    import UserHistory from './UserHistory'
    import Service from './Services/Service'
    import Penalty from './Penalty/Penalty'
    import Repair from './Repair/Repair'
    import Insurance from './Insurance/Insurance'
    import OtherReport from './OtherReport'
    import Vue from 'vue'
    Vue.use(Viewer)

    export default {
        name: 'vehicle-show',
        components: {
            RoadTax,
            Service,
            Penalty,
            Repair,
            Insurance,
            OtherReport,
            UserHistory,
        },
        data () {
            return {
                isLoading: false,
                activeTab: null,
                apiUrl: {
                    vehicle: window.AppConfig.apiUrl + 'vehicle',
                    vehiclePhoto: window.AppConfig.apiUrl + 'vehicle-photo',
                    vehicleRequest: window.AppConfig.apiUrl + 'vehicle-request'
                },
                model: {
                    merk: '',
                    model: '',
                    year: '',
                    plate: '',
                    category: {
                        name: ''
                    },
                    chassisNumber: '',
                    machineNumber: '',
                    color: '',
                    fuel: '',
                    photo1: null,
                    photo2: null,
                    photo3: null,
                    drivenBy: '',
                    engine: '',
                    transmission: '',
                    owner: '',
                    mileage: null,
                    repair: '',
                    status: '',
                    nextservice: '',
                    insurance: '',
                    roadtax: '',
                    noteRepair: '',
                    company: {
                        name: ''
                    },
                    branch: {
                        name: ''
                    },
                    note: '',
                    vehiclePhotoList: []
                },
                data: {
                    photo1File: null,
                    photo2File: null,
                    photo3File: null
                },
                modelValidations: {
                    photo1: {
                        required: false
                    }
                    // photo2: {
                    //     required: false
                    // },
                    // photo3: {
                    //     required: false
                    // }
                },
                vehicleRequestList: []
            }
        },
        mounted () {
            this.getDetail()
            this.getVehiclePhoto()
            this.getVehicleRequest()
        },
        methods: {
            getDetail () {
                this.isLoading = true
                this.$http.get(this.apiUrl.vehicle + '/' + this.$route.params.uuid)
                .then(response => {
                    this.model.uuid = response.data.uuid
                    this.model.asset = response.data.asset !== null ? response.data.asset : '-'
                    this.model.category = response.data.category !== null ? response.data.category : '-'
                    this.model.merk = response.data.merk !== null ? response.data.merk : '-'
                    this.model.model = response.data.model !== null ? response.data.model : '-'
                    this.model.year = response.data.year !== null ? response.data.year : '-'
                    this.model.machinecc = response.data.machinecc !== null ? response.data.machinecc : '-'
                    this.model.chassisNumber = response.data.chassisNumber !== null ? response.data.chassisNumber : '-'
                    this.model.machineNumber = response.data.machineNumber !== null ? response.data.machineNumber : '-'
                    this.model.color = response.data.color !== null ? response.data.color : '-'
                    this.model.fuel = response.data.fuel !== null ? response.data.fuel : '-'
                    this.model.engine = response.data.engine !== null ? response.data.engine : '-'
                    this.model.mileage = response.data.mileage !== null ? response.data.mileage : '-'
                    this.model.transmission = response.data.transmission !== null ? response.data.transmission : '-'
                    this.model.owner = response.data.owner !== null ? response.data.owner : '-'
                    this.model.plate = response.data.plate !== null ? response.data.plate : '-'
                    this.model.insurance = response.data.insurance !== undefined && response.data.insurance !== null ? response.data.insurance : '-'
                    this.model.nextservice = response.data.nextservice !== null ? response.data.nextservice : '-'
                    this.model.drivenBy = response.data.drivenBy !== null ? response.data.drivenBy : '-'
                    this.model.noteRepair = response.data.repair !== null ? response.data.repair.note : '-'
                    this.model.repair = response.data.repair !== null ? response.data.repair : '-'
                    this.model.note = response.data.note !== null ? response.data.note : '-'
                    this.model.roadtax = response.data.roadtax !== null ? response.data.roadtax : '-'
                    this.model.branch = response.data.branch !== null && response.data.branch.name !== 'null' ? response.data.branch.name : '-'
                    this.model.company = response.data.company !== null && response.data.company.name !== 'null' ? response.data.company.name : '-'
                    this.model.status = response.data.status !== null ? response.data.status : '-'
                    this.model.owner = response.data.owner !== null ? response.data.owner : '-'
                    this.model.createdAt = this.$moment(response.data.createdAt).format('YYYY-MM-DD hh:mm a')
                    this.model.updatedAt = response.data.updatedAt
                    this.model.account = response.data.account
                    this.model.qrcode = response.data.qrcode
                    this.isLoading = false
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                    // this.$router.push('/notfound')
                })
            },
            getVehiclePhoto () {
                this.isLoading = true
                this.$http.get(this.apiUrl.vehiclePhoto + '?vehicle=' + this.$route.params.uuid)
                .then(response => {
                    this.model.vehiclePhotoList = []
                    response.data._embedded.vehiclePhoto.forEach(data => {
                        this.model.vehiclePhotoList.push(data.path)
                    })
                    this.isLoading = false
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                    // this.$router.push('/notfound')
                })
            },
            getVehicleRequest () {
                this.$http.get(this.apiUrl.vehicleRequest + '?vehicle_uuid=' + this.$route.params.uuid + '&order=createdAt').then(resp => {
                    resp.data._embedded.vehicleRequest.forEach(data => {
                        this.vehicleRequestList.push(data)
                    })
                })
            },
            showModal () {
                this.resetData()
                this.$refs['my-modal'].show()
            },
            hideModal () {
                // this.resetData()
                this.$refs['my-modal'].hide()
            },
            resetData () {
                this.data.photo1File = null
                this.data.photo2File = null
                this.data.photo3File = null
            },
            onFileSelected (event) {
                this.data.photo1File = event.target.files[0]
            },
            clearImage () {
                this.$refs.photo1.value = ''
                this.data.photo1File = null
            },
            onFileSelectedPhoto2 (event) {
                this.data.photo2File = event.target.files[0]
            },
            clearImagePhoto2 () {
                this.$refs.photo2.value = ''
                this.data.photo2File = null
            },
            onFileSelectedPhoto3 (event) {
                this.data.photo3File = event.target.files[0]
            },
            clearImagePhoto3 () {
                this.$refs.photo3.value = ''
                this.data.photo3File = null
            },
            doSendPhoto () {
                this.$validator.validateAll().then(res => {
                    if (res) {
                        console.log(this.$route.params.uuid)
                        let formData = new FormData()
                        formData.append('vehicle', this.$route.params.uuid)
                        formData.append('photo1', this.model.photo1)
                        // formData.append('photo2', this.model.photo2)
                        // formData.append('photo3', this.model.photo3)
                        // if (this.data.photo2File !== null) {
                        //     formData.append('photo2', this.data.photo2File, this.data.photo2File.name)
                        // }
                        // if (this.data.photo3File !== null) {
                        //     formData.append('photo3', this.data.photo3File, this.data.photo3File.name)
                        // }
                        this.$http.post(this.apiUrl.vehiclePhoto, formData).then(response => {
                            this.$store.dispatch('notification/success', 'Vehicle photo has been added.')
                            this.getDetail()
                            this.getVehiclePhoto()
                            this.hideModal()
                        }).catch(error => {
                            this.$store.dispatch('notification/error', error)
                        })
                    }
                })
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD HH:mm A')
                } else {
                    return '-'
                }
            },
            goBack () {
                window.goBack(this)
            },
            getStatusColor (val) {
                switch (parseInt(val)) {
                case 0:
                    return 'danger'
                    // eslint-disable-next-line no-unreachable
                    break
                case 1:
                    return 'success'
                    // eslint-disable-next-line no-unreachable
                    break
                }
            },
            getStatusName (val) {
                switch (parseInt(val)) {
                case 0:
                    return 'Not Available'
                    // eslint-disable-next-line no-unreachable
                    break
                case 1:
                    return 'Available'
                    // eslint-disable-next-line no-unreachable
                    break
                }
            }
        }
    }
</script>